// this code will be a subject to extensive refactoring!!


/**
extends actionButton with with multiaction behaviour
(prepare the query string for actionButton based on which checkboxes are ticked)
*/

(function() {

var multiaction = function() {
    return {
        restrict: "E",
        scope: {
            // params: "&",
            multiactionData: "&",
            ticked: "&",
            ajaxGlobalUrl: '@'
        },
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            // for data=[Object(url,...),Object(url,...)] format
            this.joinQueries = function(data, tick) {

                // With isolated page scope option, need to flatten the tick object
                var flatTickObj = {};
                angular.forEach(tick, function(val, key){
                    flatTickObj = Object.assign(flatTickObj, tick[key]);
                });

                var joinedStr = "";
                angular.forEach(data, function(q, i) {
                    if(flatTickObj[i] == true || tick[i] == true) {
                        joinedStr += q.query;
                    }
                });
                return joinedStr;
            }
        }],
        require: ["^actionButton", "multiaction"], // require both controllers
        link: function (scope, element, attrs, ctrls) {

            var parentCtrl = ctrls[0];
            var ctrl = ctrls[1];

            var parent = new Object();
            // register parent controller function (TODO: register all parent ctrl functions?)
            parent.getMenu      = parentCtrl.getMenu;

            if( !angular.isDefined(parentCtrl.urlsData) ){
                parentCtrl.urlsData = {};
            }

            parentCtrl.getMenu = function(event) {

                var query = ctrl.joinQueries( scope.multiactionData(), scope.ticked() ); // one-way binding so getters ()

                // TODO: maybe we can create/increment here just an object of {url, query} and iterate that within getInnerMenu
                // (as semicolon version initially did)
                // parentCtrl.getInnerMenu(1, scope.ajaxGlobalUrl, query);
                // done below:
                if( angular.isDefined(scope.ajaxGlobalUrl) && scope.ajaxGlobalUrl!='' ){
                    parentCtrl.urlsData['multiaction'] = {url: scope.ajaxGlobalUrl, data: query};
                } else {
                    if( angular.isDefined(parentCtrl.urlsData['multiaction']) ){
                        delete parentCtrl.urlsData['multiaction'];
                    }
                }

                // call the original function
                return parent.getMenu(event);
            }

            parentCtrl.element.unbind("mouseover");
        }
    }
}
angular.module('app').directive('multiaction', multiaction);

}());